export default {
    items: [],
    selections: [],
    page: 1,
    loading: false,
}